function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#121212",
  d: "M54.167 25v20.833H75V32.292L92.708 50 75 67.708V54.167H54.167V75h13.541L50 92.708 32.292 75h13.541V54.167H25v13.541L7.292 50 25 32.292v13.541h20.833V25H32.292L50 7.292 67.708 25H54.167z"
});

function SvgScalable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 100 100"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01NC4xNjY2IDI1LjAwMDFWNDUuODMzNEg3NVYzMi4yOTE3TDkyLjcwODMgNTAuMDAwMUw3NSA2Ny43MDg0VjU0LjE2NjdINTQuMTY2NlY3NS4wMDAxSDY3LjcwODNMNTAgOTIuNzA4NEwzMi4yOTE2IDc1LjAwMDFINDUuODMzM1Y1NC4xNjY3SDI1VjY3LjcwODRMNy4yOTE2MyA1MC4wMDAxTDI1IDMyLjI5MTdWNDUuODMzNEg0NS44MzMzVjI1LjAwMDFIMzIuMjkxNkw1MCA3LjI5MTc1TDY3LjcwODMgMjUuMDAwMUg1NC4xNjY2WiIgZmlsbD0iIzEyMTIxMiIvPgo8L3N2Zz4K";
export { SvgScalable as ReactComponent };